module.exports = __webpack_public_path__ + "img/1.19d9000a.png";